"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var usePressets_1 = require("./usePressets");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AmountSum = function (_a) {
    var value = _a.value, onChange = _a.onChange, meta = _a.meta, errorText = _a.errorText, type = _a.type, presetOptions = _a.presetOptions;
    var errors = errorText ? errorText : meta.error ? meta.error : '';
    var buttonGroupOptions = (0, usePressets_1.usePresets)(presetOptions);
    var onPresetsChange = (0, react_1.useCallback)(function (value) {
        onChange(value);
    }, [onChange]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ui_components_1.AmountRange, { value: Number(value), step: 10, onUpdate: onChange, helperText: errors ? errors : undefined }),
            react_1.default.createElement("br", null),
            type === 'deposit' && (react_1.default.createElement(ui_components_1.ButtonGroup, { options: buttonGroupOptions, value: value, onClick: onPresetsChange })))));
};
exports.default = AmountSum;
